import AccessLogo from 'Assets/Images/Access_logo.svg';

export const TrialExpiredPage = () => {
	return (
		<div className="body-content login-page">
			<div className="login-form">
				<form className="login">
					<div className="logo-container">
						<img alt="Access Intell Group Logo" src={AccessLogo} />
					</div>
					{/* eslint-disable-next-line max-len */}
					<div className="title">
						<h5 style={{fontWeight: "700"}}>Your free trial has expired</h5>
					</div>
					<div style={{justifyContent: "center"}}>
						<p style={{fontSize: "14px", textAlign: "center"}}>
							Please contact us at <a href='mailto:support@accessintell.com' >support@accessintell.com</a> to continue using the platform
						</p>
					</div>
				</form>
			</div>
			<div className="login-gradient">
				<div className="login-pattern" />
			</div>
		</div>
	);
}